import React, { useEffect, useState } from 'react';
import useApp from 'hooks/useApp'
import styles from './index.module.css'

const AlertNone = () => {

	const App = useApp()

	useEffect(() => {
		App.setHeader({
			show: true,
			title: <></>,
			left: <i className="icon icon_arrow_back" onClick={App.goBack} />,
			right: ""
		})

		App.setShowNav(false)
		App.setMainClass("white")
	}, [])

	return (
		<div className="page">
			<div className="padding pt_10">
				<h3>알림</h3>
				<div className={`${styles["alert-title"]} mt_20`}>
					<h4>설정중인 알림 <strong className="text-blue">6</strong></h4>
					<i className="icon icon_arrow_sm right icon_arrow_md" />
				</div>
			</div>
			<div className="center-cont">
				<i className="icon icon_no_data" />
				<p className="mt_20">알림 내역이 없습니다.</p>
			</div>
			<div className="flex-shrink_0 padding">
				<div className={styles["guide-box"]}>푸시 알람을 끄면 유용한 정보를 받을 수 없어요!</div>
			</div>
		</div>
	)
}

export default AlertNone